import _ from "lodash";

/**
 * 删除当前url中指定参数
 * @param names 数组或字符串
 * @returns {string}
 */
export function deleteUrlParam(names) {
  let url = `${location.protocol}//${location.host}${location.pathname}${location.hash}`
  // names可能不存在
  if (url.indexOf(names) > -1) {
    const result = url.split('?')
    const childSplit = _.filter(result[1].split('&'), item => item.indexOf(names) < 0).join('&')
    url = `${result[0]}?${childSplit}`
  }
  return url
}
